<template>
  <div class="ChannelErrorPage">
    <img
      class="img"
      src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/icon_info.png"
    />
    <div class="info">{{ infoText }}</div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      infoText: "",
    };
  },
  mounted: function () {
    console.log(this.$route.query);
    let channel = this.$route.query.channel;
    let client = this.$route.query.client;
    let channelStr = "";
    let clientStr = "";
    switch (channel) {
      case "dxlc":
        channelStr = "道行龙城";
        break;
      case "cxnt":
        channelStr = "畅行南通";
        break;
      case "pinba":
        channelStr = "拼吧出行";
        break;
      case "linkfashion":
        channelStr = "LinkFashion AI";
        break;
    }
    switch (client) {
      case "wechat":
        clientStr = "微信小程序";
        break;
      case "app":
        clientStr = "APP";
        break;
    }

    this.infoText = `该应用仅支持通过${channelStr}${clientStr}访问`;
  },
};
</script>

<style lang="scss" scoped>
@import "./ChannelErrorPage.scss";
</style>
